import React from "react";
import Text from "@/components/ui/text";
import IcpFitValue from "@/components/controls/DetailedView/ICPFit/IcpFitValue";
import IcpFitDetailsPopover from "@/components/controls/DetailedView/ICPFit/IcpFitDetailsPopover";
import {
  IcpFit,
  IcpFitDetailBullet,
  IcpFitSubject
} from "@/entities/icpFit/types";

interface Props {
  subtitle: string;
  value: IcpFit | null | undefined;
  bullets?: IcpFitDetailBullet[] | null;
  isQuickView?: boolean;
  // Which record the score describes — drives the Unknown tooltip copy.
  subject?: IcpFitSubject;
}

const IcpFitKPICell: React.FC<Props> = ({
  subtitle,
  value,
  bullets,
  isQuickView,
  subject
}) => (
  <div className="flex flex-col gap-1 p-3 min-w-0">
    <div className="flex items-center gap-1 h-7 min-w-0">
      <IcpFitValue value={value} isQuickView={isQuickView} subject={subject} />
      <IcpFitDetailsPopover
        icpFit={value}
        bullets={bullets ?? undefined}
        previewLabel={subtitle}
      />
    </div>
    <Text variant="bodySecondary">{subtitle}</Text>
  </div>
);

export default IcpFitKPICell;
